import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadingController, NavController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatchService } from '../_core/services/match.service';

@Component({
  standalone: false,
    selector: 'app-protected-share',
    templateUrl: './protected-share.page.html',
    styleUrls: ['./protected-share.page.scss'],
})
export class ProtectedSharePage implements OnDestroy, AfterViewInit {
    loading: HTMLIonLoadingElement;
    private readonly destroy$: Subject<void> = new Subject();


    constructor(
        private route: ActivatedRoute,
        private loadingController: LoadingController,
        private navCtrl: NavController,
        private matchService: MatchService,
    ) { }

    ngAfterViewInit(): void {
        this.presentLoading();
        this.handleNavParams();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.loading.dismiss();
    }

    private handleNavParams() {
        const params = { ...this.route.snapshot.queryParams };
        if (Boolean(params.assignTracker)) {
            const { matchId, code } = params;

            this.matchService
                .validateTracker(matchId, code)
                .pipe(takeUntil(this.destroy$))
                .subscribe(
                    async res => {
                        this.navCtrl.navigateRoot(`live-scoring/${matchId}`);
                    }
                );
        }
    }

    async presentLoading() {
        this.loading = await this.loadingController.create({
            message: 'Fetching',
            spinner: 'bubbles'
        });
        await this.loading.present();
    }

}
